import { render, staticRenderFns } from "./detailCardToFilm.vue?vue&type=template&id=3c7363e9&scoped=true&"
import script from "./detailCardToFilm.vue?vue&type=script&lang=js&"
export * from "./detailCardToFilm.vue?vue&type=script&lang=js&"
import style0 from "./detailCardToFilm.vue?vue&type=style&index=0&id=3c7363e9&lang=scss&scoped=true&"
import style1 from "./detailCardToFilm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7363e9",
  null
  
)

export default component.exports